import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import css from './index.module.scss';
import { wintextObj } from './wintext';
import QuoteForm from './QuoteForm';

export default function QuoteWinSimple({ callback, className }: any) {
    const [stepVal, setStepVal] = useState('a1');
    const { locale, pathname } = useRouter();
    const wintext = wintextObj[locale as any] || wintextObj['us'];
    const [isClient, setIsClient] = useState<boolean>(false);
    const THEME_WHITE = ['/ef-quote-form', '/delta-pro-3-portable-power-station', '/calculators/delta-pro-ultra', '/power-preparedness'];
    const theme = THEME_WHITE.includes(pathname) ? 'white' : 'black';

    // 关闭
    const closeHandle = () => {
        callback && callback('close');
    };

    useEffect(() => {
        setIsClient(true);
    }, []);

    // 成功回调
    const successCallback = () => {
        setStepVal('a2');
    };

    if (isClient) {
        return ReactDOM.createPortal(
            <div
                className={`${css.VoucherWin} ${css.QuoteWinSimple} ${className} theme-${theme} GtmModuleData-section`}
                data-section-id={'dpu-QuoteWin'}
                data-section-title={'dpu-QuoteWin'}
            >
                {stepVal === 'a1' && (
                    <div className="win-container win-container-quote">
                        <span className="win-close" onClick={closeHandle}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
                                <path
                                    d="M16.25 2.70834C23.7287 2.70852 29.791 8.77159 29.791 16.2503C29.7908 23.7289 23.7286 29.7912 16.25 29.7914C8.77125 29.7914 2.70818 23.729 2.70801 16.2503C2.70801 8.77148 8.77114 2.70834 16.25 2.70834ZM21.0303 11.4701C20.6337 11.0735 19.9914 11.0735 19.5947 11.4701L16.25 14.8148L12.9053 11.4701C12.5087 11.0735 11.8664 11.0735 11.4697 11.4701C11.0731 11.8667 11.0731 12.509 11.4697 12.9056L14.8145 16.2503L11.4697 19.5951C11.0731 19.9917 11.0731 20.634 11.4697 21.0306C11.8664 21.4268 12.5088 21.4271 12.9053 21.0306L16.25 17.6859L19.5947 21.0306C19.9914 21.4268 20.6338 21.4271 21.0303 21.0306C21.4267 20.6341 21.4265 19.9917 21.0303 19.5951L17.6855 16.2503L21.0303 12.9056C21.4267 12.5091 21.4265 11.8667 21.0303 11.4701Z"
                                    fill="#83868A"
                                />
                            </svg>
                        </span>
                        <div className="win-dialog-title">{wintext.win_simple_title}</div>
                        <div className="win-dialog-desc">{wintext.win_simple_desc}</div>
                        <div className="win-mainer scrollbar-editor-black">
                            <QuoteForm callback={successCallback} simple />
                            <div className="win-form-footer">
                                {wintext.win_quote_simple_f1}
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path
                                            d="M16.8074 14.1492L13.868 11.2096C13.6906 11.0327 13.4504 10.9334 13.1999 10.9334C12.9494 10.9334 12.7091 11.0327 12.5318 11.2096L11.8637 11.8777C11.4858 12.2556 10.2621 11.8795 9.1915 10.8088C8.12094 9.73814 7.74408 8.515 8.12259 8.13662L8.79067 7.46854C8.96758 7.2912 9.06692 7.05094 9.06692 6.80046C9.06692 6.54997 8.96758 6.30971 8.79067 6.13238L5.85109 3.19293C5.67377 3.01603 5.43353 2.91669 5.18306 2.91669C4.9326 2.91669 4.69236 3.01603 4.51504 3.19293L3.84696 3.86101C3.35331 4.35465 3.05263 5.00396 2.95307 5.79096C2.86072 6.52092 2.94587 7.33957 3.20604 8.22377C3.72792 9.99996 4.90488 11.8673 6.51917 13.4811C8.13345 15.0949 10.0005 16.2724 11.7761 16.7942C12.4302 16.9866 13.0482 17.0833 13.621 17.0833C13.8177 17.0837 14.0142 17.0716 14.2094 17.0472C14.9964 16.9477 15.6457 16.647 16.1393 16.1533L16.8074 15.4852C16.9843 15.3079 17.0837 15.0677 17.0837 14.8172C17.0837 14.5668 16.9843 14.3265 16.8074 14.1492Z"
                                            stroke="#3F68E0"
                                            strokeWidth="1.33333"
                                        />
                                    </svg>
                                    <a href="facetime:+1(800)-368-8604">{wintext.win_quote_simple_f2}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {stepVal === 'a2' && (
                    <div className="win-container win-container-quote-success">
                        <span className="win-close" onClick={closeHandle}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="system/line/cancel">
                                    <path
                                        id="Combined-Shape"
                                        d="M6 5L19 18M19 5L6 18"
                                        stroke="currentColor"
                                        strokeWidth="1.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                            </svg>
                        </span>
                        <div className="win-mainer win-mainer-quote-success">
                            <div className="win-success-title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M33 18C33 26.2843 26.2843 33 18 33C9.71573 33 3 26.2843 3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18ZM23.9062 12.5303C24.1991 12.2374 24.674 12.2374 24.9669 12.5303L26.0275 13.591C26.3204 13.8839 26.3204 14.3588 26.0275 14.6517L16.4816 24.1976C16.4005 24.2787 16.3054 24.3374 16.2041 24.3735L16.1732 24.4045C15.8803 24.6974 15.4054 24.6974 15.1125 24.4045L9.53081 18.8228C9.23792 18.5299 9.23792 18.055 9.53081 17.7621L10.5915 16.7015C10.8844 16.4086 11.3592 16.4086 11.6521 16.7015L15.6936 20.7429L23.9062 12.5303Z"
                                        fill="#30BF00"
                                    />
                                </svg>
                                <span>{wintext.win_quote_success1}</span>
                            </div>
                            <div className="win-success-desc">{wintext.win_quote_success2}</div>
                        </div>
                    </div>
                )}
            </div>,
            (document as any).body,
        );
    }
    return <></>;
}
